import * as React from "react";
const SvgFiRrFaceAstonished = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-astonished_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10M8.5 12a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 8.5 12m8.5-1.5a1.5 1.5 0 1 1-3.001-.001A1.5 1.5 0 0 1 17 10.5M15 16v1a3 3 0 1 1-6 0v-1a3 3 0 1 1 6 0M6.782 8.623a1 1 0 0 1-1.406.159 1 1 0 0 1-.159-1.405c.91-1.143 2.307-2.065 3.559-2.352a1 1 0 0 1 1.198.752 1 1 0 0 1-.751 1.197c-.812.186-1.816.864-2.441 1.648zm12-1.246a1 1 0 1 1-1.565 1.246c-.625-.784-1.629-1.463-2.441-1.648a1 1 0 0 1 .447-1.949c1.252.286 2.649 1.208 3.559 2.351"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-astonished_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFaceAstonished;
